import { ValidatorFn } from '@angular/forms';
import { LabelValueObject } from '@models/company/company-size';

export enum CompanyRegisterSource {
  COMPANY = 'company',
  INTERNSHIP = 'internship',
  MENTORING = 'mentoring',
}

export enum FormQuestionType {
  Text = 'text',
  City = 'city',
  Email = 'email',
  Phone = 'phone',
  Number = 'number',
  Textarea = 'textarea',
  YesNo = 'yesNo',
  Checkbox = 'checkbox',
  Dropdown = 'dropdown',
  File = 'file',
  Siret = 'siret',
}

export interface FormQuestion {
  formControlName: string;
  required: boolean;
  baseValidators?: ValidatorFn[];

  type: FormQuestionType;

  title?: string;
  subtitle?: string;
  displayActions?: boolean;
  field?: CustomField;
  ariaLabel: string;
  tooltip?: string;
  btnLabel?: string;
  // dropdown
  options?: LabelValueObject[];

  displayCondition?(value: any): boolean;
}

export interface CustomField {
  label?: string;
  placeholder?: string;
  errorMsg?: string;
}

export interface FormQuestionSubGroup {
  hasBorder: boolean;
  questions: FormQuestion[];
  borderSelectCondition?: string;
}

export interface FormQuestionGroup {
  title?: string;
  subtitle?: string;
  description?: string;
  questionNumber?: number;
  ariaLabel: string;
  subGroups: FormQuestionSubGroup[];
  displayValidate?: {
    btnText?: string;
    errorText?: string;
  };
  validateCondition?(value: any): boolean;
}
